import React, {useEffect} from 'react';
import {makeStyles, withStyles} from '@material-ui/core/styles';
import globalContext from '../../../config/context';
import useHook from '../Pendataan/pendataan.hooks';
import './style.css';

//material core
import Button from '@material-ui/core/Button';
import {grey} from '@material-ui/core/colors';

import Dialog from '@material-ui/core/Dialog/Dialog';
import PerfectScrollbar from 'react-perfect-scrollbar';
import DialogContent from '@material-ui/core/DialogContent/DialogContent';
import {Card, CardContent, Grid, Typography} from '@material-ui/core';
import {Bar, Line} from 'react-chartjs-2';
import numeral from 'numeral';
import TrackChangesIcon from '@material-ui/icons/TrackChanges';
import Autocomplete from '@material-ui/lab/Autocomplete/Autocomplete';
import TextField from '@material-ui/core/TextField/TextField';

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },

  //button
  button: {
    // position: 'absolute',
    bottom: 30,
    borderRadius: 7,
  },

  //legend content
  box: {
    width: '100vw',
    // padding: '2vh',
    // height: 290,
    // display:'block',
    position: 'absolute',
    bottom: theme.spacing(0),
    right: theme.spacing(0),
    margin: theme.spacing(0),
    backgroundColor: 'white',
  },

  //options
  options: {
    position: 'relative',
    padding: 20,
    backgroundColor: '#fafafa',
    textAlign: 'left',
  },
  gridCaption: {
    position: 'absolute',
    bottom: 20,
  },
  caption: {
    fontSize: 18,
    fontWeight: 500,
  },
  gridComboBox: {
    marginLeft: 90,
  },
  comboBox: {
    width: '100%',
    paddingBottom: 10,
    disabled: 'true',
  },
}));

const ColorButton = withStyles((theme) => ({
  root: {
    color: theme.palette.getContrastText(grey[50]),
    backgroundColor: '#ffffff',
    '&:hover': {
      backgroundColor: '#ffffff',
    },
  },
  label: {
    // fontSize: 13,
    textTransform: 'capitalize',
  },
}))(Button);

const PendataanKelurahan = (props) => {
  const classes = useStyles();
  const {useAppContext} = globalContext;
  const [{pencarian, checkedPendataan}, {setPencarian, setCheckedPendataan}] = useAppContext();
  const [
    {onKinerjaKelurahan, kinerjaKelurahan},
    {kecamatan, setKecamatan, kecamatanOptions, setKecamatanOptions, handleKecamatan, itemKecamatan},
    {kelurahan, setKelurahan, kelurahanOptions, setKelurahanOptions, handleKelurahan, itemKelurahan},
  ] = useHook(props);

  const [open, setOpen] = React.useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  // console.log(kinerjaKelurahan);
  // kinerjaKelurahan.map((value, key) => {
  //
  // }
  const data = {
    labels: kinerjaKelurahan.map((o) => o.text),
    datasets: [
      {
        backgroundColor: ['#179d00', '#ecfc00', '#CA0617', '#20B2AA', '#9932CC', '#4169E1', '#9c4f1f'],
        borderColor: ['#179d00', '#ecfc00', '#CA0617', '#20B2AA', '#9932CC', '#4169E1', '#9c4f1f'],
        borderWidth: 1,
        data: kinerjaKelurahan.map((o) => o.jumlah),
      },
    ],
  };

  let options = {
    responsive: true,
    plugins: {
      legend: {
        display: false,
        position: 'top',
      },
    },
  };

  useEffect(() => {
    if (pencarian.kecamatan) {
      setKecamatan(pencarian.kecamatan);
      if (pencarian.kelurahan) {
        setKelurahan(pencarian.kelurahan);
      }
    }
  }, [pencarian.kecamatan, setKecamatan, pencarian.kelurahan, setKelurahan]);

  return (
    <div>
      <ColorButton
        variant="contained"
        color="default"
        size="small"
        className={classes.button}
        startIcon={<TrackChangesIcon />}
        onClick={handleClickOpen}>
        Kelurahan
      </ColorButton>
      <Dialog
        fullWidth={true}
        maxWidth="md"
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description">
        <PerfectScrollbar>
          <DialogContent style={{backgroundColor: '#efeff1'}}>
            <Grid container spacing={2}>
              <Grid item xs={12} md={3}>
                <Card style={{backgroundColor: '#4759a1', height: '100%', marginBottom: 20}}>
                  <CardContent>
                    <Typography align={'left'} variant={'h6'} style={{color: 'white'}}>
                      DATA PENDATAAN
                    </Typography>
                    <Typography align={'left'} style={{color: '#f8e354', marginTop: 10}}>
                      Jumlah Pendataan :
                    </Typography>
                    <Typography align={'left'} style={{color: '#f8e354', marginBottom: 10}}>
                      {numeral(kinerjaKelurahan[0]?.total).format('0,0')}
                    </Typography>
                    <Typography align={'left'} style={{color: '#f8e354'}}>
                      {kinerjaKelurahan.map((value, key) => {
                        return (
                          <div key={key}>
                            <div>{value.text + ' : '}</div>
                            <div style={{marginBottom: 15, marginTop: 5}}>
                              {numeral(value.jumlah).format('0,0') + ' (' + value.persen + ')'}
                            </div>
                          </div>
                        );
                      })}
                    </Typography>
                  </CardContent>
                </Card>
              </Grid>

              <Grid item xs={12} md={9}>
                <Card>
                  <CardContent>
                    <Grid container spacing={2}>
                      <Grid item xs={12} md={6}>
                        <Autocomplete
                          id="combo-box-kecamatan"
                          className={classes.comboBox}
                          options={itemKecamatan}
                          getOptionLabel={(option) => (option ? option.kd_kecamatan + ' - ' + option.nm_kecamatan : '')}
                          value={kecamatanOptions}
                          onChange={handleKecamatan}
                          renderInput={(params) => <TextField {...params} label="Kecamatan" variant="outlined" />}
                        />
                      </Grid>
                      <Grid item xs={12} md={6}>
                        <Autocomplete
                          id="combo-box-kelurahan"
                          className={classes.comboBox}
                          disabled={kecamatan === '' ? true : false}
                          options={itemKelurahan}
                          getOptionLabel={(option) => (option ? option.kd_kelurahan + ' - ' + option.nm_kelurahan : '')}
                          value={kelurahanOptions}
                          onChange={handleKelurahan}
                          renderInput={(params) => <TextField {...params} label="Kelurahan" variant="outlined" />}
                        />
                      </Grid>
                      <Grid item xs={12} md={12}>
                        <Bar data={data} options={options} />
                      </Grid>
                    </Grid>
                  </CardContent>
                </Card>
              </Grid>
            </Grid>
          </DialogContent>
        </PerfectScrollbar>
      </Dialog>
    </div>
  );
};
export default PendataanKelurahan;
